import { LoginCallback, Security } from "@okta/okta-react";
import { OktaAuth, OktaAuthOptions, toRelativeUrl } from "@okta/okta-auth-js";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { getENV } from "../utils";
import {
  OKTA_AUTHORIZE_URIS,
  OKTA_CLIENT_ID,
  OKTA_ISSUER,
  OKTA_LOG_OFF,
  OKTA_TOKEN_URL,
} from "../pages/common/constants";
import AuthGate from "../AuthGate";
import Logout from "../routes/Logout";

const getOktaConfig = (): OktaAuthOptions => {
  const env = getENV();

  return {
    issuer: OKTA_ISSUER[env],
    clientId: OKTA_CLIENT_ID[env],
    redirectUri: `${window.location.origin}/login/callback`,
    authorizeUrl: OKTA_AUTHORIZE_URIS[env],
    tokenUrl: OKTA_TOKEN_URL[env],
    logoutUrl: OKTA_LOG_OFF[env],
    scopes: ["openid", "profile", "email"],
    pkce: true,
  };
};

const restoreOriginalUri = (_auth: OktaAuth, originalUri: string): void => {
  const url = toRelativeUrl(originalUri || "/", window.location.origin);

  window.location.replace(url);
};

const oktaAuth = new OktaAuth(getOktaConfig());

const AuthRoutes = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <Routes>
    <Route path="/login/callback" element={<LoginCallback />} />
    <Route path="/logout" element={<Logout />} />
    <Route path="*" element={<AuthGate>{children}</AuthGate>} />
  </Routes>
);

export default function AuthProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>): JSX.Element {
  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <AuthRoutes>{children}</AuthRoutes>
      </Security>
    </BrowserRouter>
  );
}
